export const blockIconsToggleIndeterminateCheckBox = (
	<span className='material-symbols-outlined'>indeterminate_check_box</span>
);
